import { COLLECTIONS_TOGGLE_COLLECTION_UPDATE } from './constants';

export function toggleCollectionUpdate() {
  return {
    type: COLLECTIONS_TOGGLE_COLLECTION_UPDATE,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COLLECTIONS_TOGGLE_COLLECTION_UPDATE:
      return {
        ...state,
        isOpenCollectionUpdateModel: !state.isOpenCollectionUpdateModel,
      };

    default:
      return state;
  }
}
